import React from 'react';
import jMoment from 'moment-jalaali';
import { STATUS_CODE_OPTIONS, CLEAR_INSTALLMENT_TOOL_CODE } from '../../constants/Options';
import { PriceLabel } from 'components';

const columns = (SeeDetailBtn , actionsList ,  currencyText) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه',
    field: 'id',
    align: 'center',
    filtering: false,
    sorting: false,
  },
  {
    title: 'تسهیلات دهنده',
    field: 'business',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => rd?.business?.name ?? '-',
  },
  {
    title: `مبلغ (${currencyText})`,
    field: 'totalAmount',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => <PriceLabel amount={rd.totalAmount} />
  },
  {
    title: 'تاریخ ایجاد',
    field: 'settledDate',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => jMoment(rd?.creationDate).format('jYYYY/jMM/jD'),
  },
  {
    title: 'پیش پرداخت',
    field: 'primaryAmount',
    align: 'center',
    filtering: false,
    sorting: false,
  },
  {
    title: 'منبع پرداخت اقساط',
    field: 'clearInstallmentToolCode',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) =>
      CLEAR_INSTALLMENT_TOOL_CODE.find((o) => o.value === rd.clearInstallmentToolCode)?.label ??
      '-',
  },
  {
    title: 'شماره وثیقه',
    field: 'assuranceNumber',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => rd?.assuranceNumber ?? '-',
  },
  {
    title: 'وضعیت',
    field: 'status',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => STATUS_CODE_OPTIONS.find((s) => s.value === rd.statusCode)?.label ?? '-',
  },
  ...((actionsList['loanDetailAction'] || actionsList['loanPayAction']) ? [{
    title: 'عملیات',
    field: 'operation',
    filtering: false,
    align: 'center',
    sorting: false,
    render: (rd) => <SeeDetailBtn rd={rd} actionsList={actionsList} />,
  }] : []),
];

const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      ...row,
    };
  });

  return newData;
};

export { columns, generateData };
